import axios from 'axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function get(url?: string): Promise<any> {
  const dataUrl = url ?? (process.env.REACT_APP_JSON_DATA_URL as string);
  return axios.get(dataUrl);
}
